import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { getEntities } from '../../global-selectors';
import { selectActivePlanSubscription } from './products';
import { get } from 'lodash';

const createNoMemoSelector = createSelectorCreator(defaultMemoize, () => false);

export const selectTransactionsEntities = createSelector(
  getEntities,
  entities => get(entities, 'transactions.all', [])
);

export const selectTransactionByExternalId = createNoMemoSelector(
  selectTransactionsEntities,
  selectActivePlanSubscription,
  (transactions, mainSubscription) => {
    const externalId = mainSubscription?.purchaseState?.externalId;
    return transactions.find((transaction) => transaction?.externalId === externalId);
  }
);